// Çizim editöründeki callout sprite'ı için canvas üretir. Üst kısımda
// (varsa) yazar/rol bilgisini gösteren bir başlık bandı; altında iç
// kenarlıklı, kelime kaydırmalı not metni.
//
// Kullanım: hem yeni not çizerken (useDrawCallout) hem sunucudan gelen
// notları sahneye eklerken (useCalloutSync) ortak görünüm.

const FONT_SIZE = 14;
const HEADER_FONT_SIZE = 11;
const PADDING = 8;
const BOX_WIDTH = 200;
// Başlık bandı yüksekliği — küçük tek satırlık metin için yeterli.
const HEADER_BAND_H = 20;
// Başlıksız notlarda gövde için kullanılan minimum yükseklik (eski 60px).
const BODY_MIN_H = 60;

function wrapLines(ctx, text, maxWidth) {
  const words = (text || '').split(/\s+/).filter(Boolean);
  const lines = [];
  let line = '';
  for (const word of words) {
    const test = line ? `${line} ${word}` : word;
    if (ctx.measureText(test).width > maxWidth && line) {
      lines.push(line);
      line = word;
    } else {
      line = test;
    }
  }
  if (line) lines.push(line);
  return lines;
}

function fitHeader(ctx, header, maxWidth) {
  let txt = header;
  while (ctx.measureText(txt).width > maxWidth && txt.length > 3) {
    txt = txt.slice(0, -2);
  }
  return txt.length < header.length ? `${txt}…` : txt;
}

// Sabit boyutlu kanvas (geniş projeler için tahmin edilebilir sprite ölçeği)
// → BOX_WIDTH × (HEADER_BAND_H? + BODY_MIN_H). Header yoksa header bandı çizilmez.
//
// Dönüş: { canvas, width, height } — canvas, sprite texture'ı için kullanılır.
export function drawCalloutCanvas({ header, text, color = '#00ccff' }) {
  const canvas = document.createElement('canvas');
  const dpr = window.devicePixelRatio || 1;
  const scale = dpr * 4;
  const cssWidth = BOX_WIDTH;
  const headerH = header && header.trim() ? HEADER_BAND_H : 0;
  const cssHeight = headerH + BODY_MIN_H;

  canvas.width = cssWidth * scale;
  canvas.height = cssHeight * scale;
  const ctx = canvas.getContext('2d');
  ctx.scale(scale, scale);

  // Arka plan
  ctx.fillStyle = 'rgba(0, 0, 0, 0.7)';
  ctx.fillRect(0, 0, cssWidth, cssHeight);

  // Başlık bandı
  if (headerH) {
    ctx.fillStyle = color;
    ctx.globalAlpha = 0.22;
    ctx.fillRect(0, 0, cssWidth, headerH);
    ctx.globalAlpha = 1;
    ctx.beginPath();
    ctx.strokeStyle = color;
    ctx.lineWidth = 1;
    ctx.moveTo(0, headerH);
    ctx.lineTo(cssWidth, headerH);
    ctx.stroke();

    ctx.font = `bold ${HEADER_FONT_SIZE}px Arial`;
    const fitted = fitHeader(ctx, header.trim(), cssWidth - PADDING * 2);
    ctx.fillStyle = '#ffffff';
    ctx.textBaseline = 'middle';
    ctx.fillText(fitted, PADDING, headerH / 2);
  }

  // Dış kenarlık
  ctx.strokeStyle = color;
  ctx.lineWidth = 2;
  ctx.strokeRect(1, 1, cssWidth - 2, cssHeight - 2);

  // Gövde metni
  ctx.fillStyle = color;
  ctx.font = `${FONT_SIZE}px Arial`;
  ctx.textBaseline = 'top';
  const lines = wrapLines(ctx, text || '', cssWidth - PADDING * 2);
  let y = headerH + PADDING;
  const lineH = FONT_SIZE * 1.4;
  for (const ln of lines) {
    ctx.fillText(ln, PADDING, y);
    y += lineH;
  }

  return { canvas, width: cssWidth, height: cssHeight };
}

export const CALLOUT_BOX_WIDTH = BOX_WIDTH;
export const CALLOUT_HEADER_BAND_H = HEADER_BAND_H;
export const CALLOUT_BODY_MIN_H = BODY_MIN_H;
